Ember.libraries.register('Ember Simple Auth', '3.1.0-beta.0');